import styled from 'styled-components'

const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
`

export default FormGroup
